<script>
    import {onMount} from "svelte";

    export let inputId;
    export let store;
    export let readOnly;
    export let required = false;

    let input;
    import QuoteSvg from "../svg/QuoteSvg.svelte";
    onMount(() => {
        if(inputId) input.id = inputId;
        if(required) input.setAttribute("required", "true");
        if(readOnly) {
            input.setAttribute("readonly", "true");
            input.style.cursor = 'default';
            input.setAttribute("placeholder", "")
        }
    });
    //TODO(mikol): we should add a script here to auto expand vertically
</script>

<style>

    .message-box-outer-container {
        position: relative;
        margin-top: 42px;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .message-box-inner-container {
        position: relative;
        width: 1000px;
        max-width: calc(100% - 40px);
        margin: 0 20px;
    }

    .quote-container {
        position: absolute;
        top: -34px;
        left: 12px;
        transition: all 0.3s;
    }

    textarea {
        outline: none;
        border:none;
        width: 100%;
        background: white;
        box-shadow: 4px 8px 20px rgba(215, 74, 9, 0.4);
        border-radius: 12px;
        height: 240px;
        padding: 28px;
    }
    textarea::placeholder {
        color:#C8C8C8;
        opacity: 1;
    }

    .message-box-inner-container:hover textarea {
        box-shadow: 4px 8px 36px rgba(215, 74, 9, 1);
    }

    .message-box-inner-container:hover .quote-container {
        top: -38px;
    }

    @media screen and (max-width: 768px) {
        textarea {
            font-size: 16px;
        }
    }

</style>

<div class="message-box-outer-container">
    <div class="message-box-inner-container">
        <div class="quote-container">
            <QuoteSvg/>
        </div>
        <textarea id="message-box" bind:value={$store} bind:this={input} on:input={(v) => $store = v.target.value} placeholder="Type your message here..."></textarea>
    </div>
</div>
